export enum popupStatus {
  CLOSED = 'CLOSED',
  LOADING = 'LOADING',
  OPEN = 'OPEN',
}
